//#region recipes/conversation_view/feed_item_pill/feed_item_pill_constants.js
var e = {
	default: "d-recipe-feed-item-pill__border--default",
	ai: "d-recipe-feed-item-pill__border--ai",
	critical: "d-recipe-feed-item-pill__border--critical"
}, t = { FEED_ITEM_PILL_BORDER_COLORS: e };
//#endregion
export { e as FEED_ITEM_PILL_BORDER_COLORS, t as default };

//# sourceMappingURL=feed-item-pill-constants.js.map